export const LanguagesConstant = {
    EN: 'en',
    AR: 'ar'
}
